import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/bror/behaviors/addProduct';

const wallInteriorsProductListConfig: ProductListConfig = {
  cardsSubtitle: 'typeName, designText',
  infoButtonAriaLabel: 'storageone.productListInteriorsTitle',
  sortOrder: [],
  categories: [
    {
      id: 'wall-interiors',
      products: [
        { path: 'type', value: ProductType.BROR_SHELF_WALL_METAL_BLACK },
        { path: 'type', value: ProductType.BROR_RAIL },
        { path: 'type', value: ProductType.BROR_PEGBOARD_SET }
      ]
    }
  ],
  productFilters: [],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  cluster: []
};

export default wallInteriorsProductListConfig;
